import React from 'react';

interface TableProps {
  headers: string[];
  data: Array<{ id: string; [key: string]: any }>;
  actions?: (item: any) => React.ReactNode;
  renderCell?: (item: any, header: string) => React.ReactNode;
}

export const Table: React.FC<TableProps> = ({ headers, data, actions, renderCell }) => {
  return (
    <div className="card overflow-hidden !p-0 border border-slate-200/80 dark:border-slate-800/80">
      <div className="overflow-x-auto w-full">
        <table className="w-full text-left border-collapse min-w-[600px] sm:min-w-full">
          <thead>
            <tr className="bg-slate-50/80 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-800 text-xs uppercase tracking-wider font-bold text-slate-500 dark:text-slate-400">
              {headers.map((header) => (
                <th
                  key={header}
                  className="px-4 sm:px-6 py-3.5 whitespace-nowrap"
                >
                  {header}
                </th>
              ))}
              {actions && (
                <th className="px-4 sm:px-6 py-3.5 text-right whitespace-nowrap">
                  İşlemler
                </th>
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 dark:divide-slate-800/60 text-sm">
            {data.length > 0 ? (
              data.map((item) => (
                <tr
                  key={item.id}
                  className="table-row hover:bg-slate-50/80 dark:hover:bg-slate-800/40 transition-colors"
                >
                  {headers.map((header) => (
                    <td
                      key={`${item.id}-${header}`}
                      className="px-4 sm:px-6 py-3.5 text-slate-700 dark:text-slate-200 align-middle"
                    >
                      {renderCell ? renderCell(item, header) : item[header.toLowerCase()] || '-'}
                    </td>
                  ))}
                  {actions && (
                    <td className="px-4 sm:px-6 py-3.5 text-right align-middle whitespace-nowrap">
                      <div className="inline-flex items-center justify-end gap-1">
                        {actions(item)}
                      </div>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={headers.length + (actions ? 1 : 0)}
                  className="px-6 py-12 text-center text-slate-400 dark:text-slate-500 font-medium"
                >
                  <p className="text-base">📦 Veri bulunamadı</p>
                  <p className="text-xs text-slate-400 mt-1">Listelenecek herhangi bir öge mevcut değil.</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
